import React, { useEffect, useState } from "react";
import MyTable from "../dataTable";
import { toReadableDate } from "../../utils/utilityFunctions";
import CertificateService from "../../services/certificateService";
import Spinner from "../../utils/spinner";
import { checkUserPermission } from "../../utils/utilityFunctions";

export default function CertificateListComponent({ dataList }) {
  const [tableData, setTableData] = useState(dataList);
  const [initializing, setInit] = useState(true);

  const headerList = [
    {
      Header: "",
      accessor: "deleteButton",
    },
    {
      Header: "",
      accessor: "editButton",
    },
    {
      Header: "Certificate",
      accessor: "certificateName",
    },
    {
      Header: "Issuing Authority",
      accessor: "issuerName",
    },
    {
      Header: "Place of Issue",
      accessor: "placeOfIssueName",
    },
    {
      Header: "Validity Period",
      accessor: "dateComponent",
    },
    {
      Header: "Status",
      accessor: "statusComponent",
    },
  ];

  useEffect(async () => {
    setInit(true);

    setTableData(dataList);
    setInit(false);
  }, [dataList, tableData]);

  return (
    <div
      style={{
        overflow: "auto",
        boxShadow: "rgb(221, 221, 221) 2px 2px 5px 0.1px",
        width: "100%",
      }}
    >
      {initializing && (
        <div className="center">
          <Spinner />
        </div>
      )}
      {!initializing && (
        <MyTable
          columns={headerList}
          cssArray={["font-weight-500", "", "", "text-right"]}
          data={dataList || []}
          disablePageSize={true}
          enableSearch={false}
          emptyMessage="You have not added any compliance records"
        />
      )}
    </div>
  );
}
